export const VISIME_THEME_PREFERENCE_KEY = 'visime_theme_preference';
export const VISIME_THEME_CHANGED = 'visime-theme-changed';

export type ThemePreference = 'system' | 'light' | 'dark';
export type ColorMode = 'light' | 'dark';

export function getThemePreference(): ThemePreference {
  try {
    const raw = localStorage.getItem(VISIME_THEME_PREFERENCE_KEY);
    if (raw === 'light' || raw === 'dark' || raw === 'system') return raw;
  } catch {
    /* ignore */
  }
  return 'system';
}

export function getSystemColorMode(): ColorMode {
  if (typeof window === 'undefined' || !window.matchMedia) return 'light';
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function resolveColorMode(preference: ThemePreference = getThemePreference()): ColorMode {
  if (preference === 'light' || preference === 'dark') return preference;
  return getSystemColorMode();
}

export function setThemePreference(preference: ThemePreference): void {
  try {
    localStorage.setItem(VISIME_THEME_PREFERENCE_KEY, preference);
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new CustomEvent(VISIME_THEME_CHANGED, { detail: preference }));
}
